import { render, staticRenderFns } from "./TodoQuery.vue?vue&type=template&id=4c0e3448&"
import script from "./TodoQuery.vue?vue&type=script&lang=js&"
export * from "./TodoQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports